<div class="container">
  <h1 class="h1-xs">Mylly has moved</h1>
  Mylly is available in
  <a href="https://mylly.rahtiapp.fi">https://mylly.rahtiapp.fi</a>
</div>
